import Header from '../../components/Public/markup/Header';
import Title from '../../components/Public/markup/Title';
import CardsList from '../../components/Public/markup/CardsList';
import MapBtn from '../../components/Public/markup/MapBtn';
import Tags from '../../components/Public/markup/Tags';
import FilterForm from '../../components/Public/markup/FilterForm';
import FilterToggleBtn from '../../components/Public/markup/FilterToggleBtn';
import MapBlock from '../../components/Public/markup/MapBlock';
import TopBar from '../../components/Public/markup/TopBar';

import useMedia from '../../hooks/useMedia';
import useFilter from '../../hooks/useFilter';
import { getSuffix } from '../../utils';
import SubmitButton from '../../components/SubmitButton';
import Dropdown from '../../components/core/Dropdown';
import { sortlistAssignments, sortlistPrimary } from '../../hooks/useFilter/filterSets';
import Preloader from '../../components/Preloader';
import LoadMoreSpinner from '../../components/LoadMoreSpinner';
import RealtyMap from '../../components/Public/markup/Map';
import {
  extractAssignmentsMapItems,
  extractCommercialMapItems,
} from '../../hooks/useFilter/filterUtils';

import { useParams } from 'react-router-dom';
import { useMemo, useRef } from 'react';
import { useState } from 'react';

import { useModal } from 'react-modal-hook';
import Wrap from '../../components/core/ModalWrap';
import MobileModal from '../../components/core/MobileModal';
import Modal from '../../components/core/Modal';
import AssignationPublicCard from '../../components/Public/markup/Containers/AssignationPublicCard';
import MapFilters from '../../components/Public/markup/MapFilters/Index';
import FilterDisabled from '../../components/Public/FilterDisabled';
import PrimaryPublicFilters from '../../components/Public/markup/PrimaryPublicFilters';
import cloneDeep from 'lodash/cloneDeep';
import AssignmentsDetailList from '../../components/Public/markup/detail/DetailList/AssignmentsDetailList';
import useRootCSS from '../../hooks/useRootCSS';
import PublicMobileFilter from '../../components/Public/markup/MapFilters/PublicMobileFilter';

const PublicAssignments = () => {
  const isTablet = useMedia('isTablet');
  const isLaptop = useMedia('isLaptop');
  const isMobile = useMedia('isMobile');
  const { savedFilterXmlId } = useParams();
  const extractSubItems = (setData, resp) => {
    const assignments = resp.assignments?.types;
    const type = assignments?.[0];
    setData((prev) => {
      const tmp = cloneDeep(prev);
      const currentAssignmentsType = tmp.assignments?.types.findIndex(
        ({ roomTypeId }) => roomTypeId === type.roomTypeId,
      );
      tmp.assignments.types[currentAssignmentsType] = type;
      return tmp;
    });
  };
  const {
    handleFilter,
    submit,
    isLoading,
    infiniteRef,
    filter = {},
    exclude = {},
    count,
    data: {
      assignments = [],
      filter: filterData = {},
      agent,
      isActive,
      isShowFilter,
      savedFilterSettings,
      savedFilter,
    },
    showSkeleton,
    setFilterAndExclude,
    filterBadges,
    removeBadge,
    loadSubItems,
    isCountLoading,
    view,
    setView,
    mapItems,
    dispatchMap,
    mapState,
    resetFilter,
    submitMap,
    isMapItemsLoading,

    clearFilter,
    clearExclude,
    filterLength,
    isExcludeEmpty,
    isFilterEmpty,
    switchFilterToExclude,
    limit,
    moreIsLoading,
    createBadges,
    handleSort,
    sortId,
  } = useFilter({
    //TO DO: вынести конфиги фильтров отдельно
    apiConfig: {
      component: 'panpartner:assignments.ajax',
      submitFunction: 'getAssignments',
      getCountFunction: 'getCount',
      loadSubItems: 'getAssignments',
      getMapItems: 'getMapAssignments',
    },
    defaultFilter: {
      status: [1],
    },
    defaultParams: {
      savedFilterXmlId,
      isGroup: 0,
    },
    shadowFilters: ['status'],
    fields: {
      buildings: [],
      blocks: [],
      status: [],
      decoration: [],
      rooms: [],
      endings: {},
      prices: {},
      isOnlyHanded: '',
    },
    defaultOrder: 'price',
    defaultBy: 'asc',
    defaultSortId: "0",
    sortEnabled: true,
    paginationEnabled: true,
    sortList: sortlistAssignments,
    loadMoreEnabled: true,
    isGetFilter: true,
    loadMoreDataKey: 'assignments',
    // disableLoadMapItems: true,
    extractCount: ({ count }) => count,
    extractMapItems: ({ assignments }) => assignments,
    extractSubItems,
    extractLoadMoreCount: ({ count }) => count,
  });
  useRootCSS({
    '--colorButton': savedFilterSettings?.colorButton,
    '--colorHeader': savedFilterSettings?.colorHeader,
    '--colorButtonText': savedFilterSettings?.colorButtonText,
    '--colorHeaderText': savedFilterSettings?.colorHeaderText,
    '--colorHover': savedFilterSettings?.colorHover,
  });
  const [showMapBlock, setShowMapBlock] = useState(true);
  const showHintRef = useRef(null);
  const [openFilter, closeFilter] = useModal(
    () => (
      <Wrap
        wrapper={(children) =>
          isMobile ? (
            <MobileModal
              className="sf-mobile"
              closeClick={closeFilter}
              title="Параметры фильтра"
            >
              {children}
            </MobileModal>
          ) : (
            <Modal close={closeFilter} classes="modal_task">
              {children}
            </Modal>
          )
        }
      >
        {!isLoading && (
          <PublicMobileFilter
            component={PrimaryPublicFilters}
            filterData={filterData}
            filter={filter}
            exclude={exclude}
            setFilterAndExclude={setFilterAndExclude}
            handleFilter={handleFilter}
            count={`${count} объект${getSuffix(count)}`}
            onSumbit={() => {
              closeFilter();
              submit();
            }}
            isLoading={isCountLoading || isLoading}
            disableSubmit={!count}
            isMobile={isMobile}
            resetFilter={resetFilter}
            loaderColor={savedFilterSettings?.colorButtonText}
          />
        )}
      </Wrap>
    ),
    [isLoading, filterData, filter, exclude, count, isCountLoading, isMobile],
  );
  const badges = useMemo(
    () =>
      isShowFilter || !savedFilter?.filter
        ? filterBadges
        : createBadges(savedFilter?.filter),
    [filterBadges, savedFilter],
  );
  if (isLoading) return <Preloader loading={true} />;
  if (!isActive) return <FilterDisabled agent={agent} />;
  if (view === 'map')
    return (
      <div className="sf sf_map">
        <RealtyMap
          dispatch={dispatchMap}
          {...mapState}
          mapCenter={[59.9342802, 30.3350986]}
          items={mapItems}
          extractFeatures={extractAssignmentsMapItems}
          isLoading={isMapItemsLoading}
          innerCbRef={showHintRef}
          onObjectClick={() => setShowMapBlock(true)}
          savedFilterSettings={savedFilterSettings}
        />
        <div className="sf__map-top">
          <TopBar setShowMap={setView} />
        </div>
        <MapBlock
          items={
            mapState?.selectedItems?.length ? mapState.selectedItems : mapItems
          }
          filterData={filterData}
          filter={filter}
          exclude={exclude}
          setFilterAndExclude={setFilterAndExclude}
          handleFilter={handleFilter}
          cardComponent={AssignationPublicCard}
          getLink={({ id }) =>
            `/public/assignments/${savedFilterXmlId}/spb/${id}`
          }
          resetFilter={resetFilter}
          MapFilterBlock={MapFilters}
          component={PrimaryPublicFilters}
          withoutBtnsList={true}
          count={`${count} объект${getSuffix(count)}`}
          onSumbit={submitMap}
          disableSubmit={!count}
          isLoading={isCountLoading || isLoading}
          showFilters={mapState.showFilters}
          setShowFilters={(val) =>
            dispatchMap({ type: 'setData', payload: { showFilters: val } })
          }
          onMouseMove={(id) => showHintRef.current(id)}
          showBlock={showMapBlock}
          setShowBlock={setShowMapBlock}
          isShowFilter={isShowFilter}
          loaderColor={savedFilterSettings?.colorButtonText}
        />
      </div>
    );

  return (
    <div className="sf wrapper">
      <Header {...agent} savedFilterSettings={savedFilterSettings} />

      {!savedFilterSettings?.hideTitle && (
        <Title
          title={
            savedFilterSettings?.title
              ? savedFilterSettings?.title
              : `Переуступки Санкт-Петербурга`
          }
        />
      )}
      {!isTablet && (
        <>
          {isShowFilter && (
            <div className="sf__filter form">
              <PrimaryPublicFilters
                filterData={filterData}
                filter={filter}
                exclude={exclude}
                setFilterAndExclude={setFilterAndExclude}
                handleFilter={handleFilter}
                count={`${count} объект${getSuffix(count)}`}
                onSumbit={submit}
                isLoading={isCountLoading || isLoading}
                disableButton={!count}
              />
            </div>
          )}
          <div style={{marginTop: 25}}>
            <Tags
              badges={badges}
              removeBadge={removeBadge}
              resetFilter={resetFilter}
              readonly={!isShowFilter}
            />
          </div>
        </>
      )}

      {isLaptop && !isTablet && (
        <SubmitButton
          className="sf__filter-btn btn btn_primary h6"
          onClick={submit}
          isLoading={isCountLoading || isLoading}
          type="button"
          disabled={!count}
          loaderColor={savedFilterSettings?.colorButtonText}
        >
          {`${count} объект${getSuffix(count)}`}
        </SubmitButton>
      )}

      <div className="sf__row">
      {!isTablet && (
          <div className="special-filter-drop">
            <Dropdown
              innerClass={``}
              value={sortId}
              options={sortlistAssignments}
              onChange={handleSort}
            />
          </div>
        )}
        <div className="sf__filter-btns">
          {isTablet && isShowFilter && <FilterToggleBtn onClick={openFilter} />}
          <MapBtn setShowMap={() => setView('map')} />
          {!isLaptop && (
            <SubmitButton
              className="sf__filter-btn btn btn_primary h6"
              onClick={submit}
              isLoading={isCountLoading || isLoading}
              type="button"
              disabled={!count}
              loaderColor={savedFilterSettings?.colorButtonText}
            >
              {`${count} объект${getSuffix(count)}`}
            </SubmitButton>
          )}
        </div>
      </div>
      {/* <AssignmentsDetailList
        items={assignments.types}
        loadItems={loadSubItems}
        showSkeleton={showSkeleton}
      /> */}

      <CardsList
        withoutBtnsList={true}
        items={assignments}
        limit={limit}
        isLoading={showSkeleton}
        itemsRef={infiniteRef}
        cardComponent={AssignationPublicCard}
        getLink={({ id }) =>
          `/public/assignments/${savedFilterXmlId}/spb/${id}`
        }
        listClass="sf__cards-list sf__cards-list_flats"
      />

      <LoadMoreSpinner loading={moreIsLoading} />
    </div>
  );
};

export default PublicAssignments;
